__turbopack_context__.v({
  "--has-full-width-image": "page-module-scss-module__-Y4r4q__--has-full-width-image",
  "--is-fixed-height": "page-module-scss-module__-Y4r4q__--is-fixed-height",
  "--is-squeezing": "page-module-scss-module__-Y4r4q__--is-squeezing",
  "--modal-is-in": "page-module-scss-module__-Y4r4q__--modal-is-in",
  "__auth-container": "page-module-scss-module__-Y4r4q____auth-container",
  "__background-image": "page-module-scss-module__-Y4r4q____background-image",
  "__confirmation-code": "page-module-scss-module__-Y4r4q____confirmation-code",
  "__terms-container": "page-module-scss-module__-Y4r4q____terms-container",
  "page": "page-module-scss-module__-Y4r4q__page",
  "question-or-ad": "page-module-scss-module__-Y4r4q__question-or-ad",
});
